<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
    <ion-title>Ausbildungsplan</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="saveEducationCategory()"
        [disabled]="!this.educationCategoryForm.valid"
        [strong]="true"
        >Speichern</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form
    [formGroup]="educationCategoryForm"
    class="bg-iosbackground dark:bg-transparent pt-5"
  >
  <ion-list class="mt-5 mb-5">
    <ion-item class="input-has-focus">
      <ion-note slot="start">
        <ion-icon
          color="primary"
          name="document-outline"
          class="text-lg"
        ></ion-icon>
      </ion-note>
      <ion-input
        #input
        label="Bezeichnung"
        formControlName="name"
        [placeholder]="'z.B. Ausbildungsplan Kat. ' + educationCategoryForm.value.category"
      ></ion-input>
    </ion-item>
    <ion-item lines="full">
      <ion-note slot="start">
        <ion-icon
          color="primary"
          name="car-outline"
          class="text-lg"
        ></ion-icon>
      </ion-note>
      <ion-select
        label="Kategorie"
        aria-label="Kategorie"
        formControlName="category"
        value="B"
        okText="Festlegen"
        cancelText="Abbrechen"
      >
      @for (categoryOption of categoryOptions(); track categoryOption) {
        <ion-select-option [value]="categoryOption">{{ categoryOption }}</ion-select-option>
      }
      </ion-select>
    </ion-item>
  </ion-list>
  </form>
</ion-content>
